import React, { useEffect } from 'react'
import { purgeSessionCookiesOnLogin } from './purgeSessionCookiesOnLogin'

/**
 * Al cargar la app, quita cookies de cliente obsoletas (RBAC/PII) de builds anteriores de Torre.
 * Las credenciales de sesión siguen en cookies HttpOnly del servidor y el access token en memoria.
 */
export function SessionProfileProvider({ children }) {
  useEffect(() => {
    purgeSessionCookiesOnLogin()
  }, [])

  return children
}
